/**
 * Transforma URLs em texto plano em tags <a> clicáveis.
 * Usado ao renderizar HTML de comentários via dangerouslySetInnerHTML.
 *
 * Só converte URLs que NÃO estejam dentro de uma tag href= (já linkadas).
 */

const URL_RE = /(?<!['"=])(https?:\/\/[^\s<>"']+)/g;

export function linkifyHtml(html: string): string {
  // Processa apenas o texto fora de tags existentes
  return html.replace(/>([^<]*)</g, (match, text: string) => {
    const linked = text.replace(URL_RE, (url: string) => {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-[var(--accent)] underline">${url}</a>`;
    });
    return `>${linked}<`;
  });
}
